export default __webpack_public_path__ + "static/media/recipe_s.9080b5fb.jpg";